import api from '@/libs/api'
import store from '@/store'

const organizationId = () => store.state.app.organizationId

export default {
  namespaced: true,
  state: {
    loading: false,
    organizations: [],
    organization: {},
    fetchingOrganizations: false,
    addingOrganization: false,
    updatingOrganization: false,
    gettingOrganization: false,
    organizationsResultInfo: {},
    organizationsCurrentPage: 1,
    users: [],
    user: {},
    fetchingUsers: false,
    addingUser: false,
    updatingUser: false,
    removingUser: false,
    gettingUser: false,
    invitingUser: false,
    resultInfo: {},
    currentPage: 1,
    clientSecret: '',
    billingDetails: [],
    fetchingPaymentIntent: false,
    confirmingCard: false,
    gettingBillingDetails: false,
    removingBillingDetails: false,
    gettingPortalSession: false,
    portalSession: {},
    fetchingCountries: false,
    countries: [],
  },
  getters: {
    organizationsCurrentPage: state => state.organizationsCurrentPage,
    currentPage: state => state.currentPage,
  },
  mutations: {
    // API
    SET_ORGANIZATIONS(state, data) {
      state.organizations = data.result
      state.organizationsResultInfo = data.resultInfo
    },
    GET_ORGANIZATION(state, organization) {
      state.organization = organization
    },
    SET_FETCHING_ORGANIZATIONS(state, value) {
      state.fetchingOrganizations = value
    },
    SET_ADDING_ORGANIZATION(state, value) {
      state.addingOrganization = value
    },
    SET_UPDATING_ORGANIZATION(state, value) {
      state.updatingOrganization = value
    },
    SET_GETTING_ORGANIZATION(state, value) {
      state.gettingOrganization = value
    },
    SET_USERS(state, data) {
      state.users = data.result
      state.resultInfo = data.resultInfo
    },
    GET_USER(state, user) {
      state.user = user
    },
    SET_FETCHING_USERS(state, value) {
      state.fetchingUsers = value
    },
    SET_ADDING_USER(state, value) {
      state.addingUser = value
    },
    SET_UPDATING_USER(state, value) {
      state.updatingUser = value
    },
    SET_REMOVING_USER(state, value) {
      state.removingUser = value
    },
    REMOVE_USER(state, id) {
      state.users = state.users.filter(u => u.id !== id)
    },
    SET_GETTING_USER(state, value) {
      state.gettingUser = value
    },
    SET_INVITING_USER(state, value) {
      state.invitingUser = value
    },
    SET_SECRET(state, res) {
      state.clientSecret = res.clientSecret
    },
    SET_ORGANIZATION_ID(state, id) {
      state.organizationId = id
    },
    SET_BILLING_DETAILS(state, res) {
      state.billingDetails = [res]
    },
    SET_FETCHING_PAYMENT_INTENT(state, value) {
      state.fetchingPaymentIntent = value
    },
    SET_CONFIRMING_CARD(state, value) {
      state.confirmingCard = value
    },
    SET_GETTING_BILLING_DETAILS(state, value) {
      state.getBillingDetails = value
    },
    SET_REMOVING_BILLING_DETAILS(state, value) {
      state.removingBillingDetails = value
    },
    SET_GETTING_PORTAL_SESSION(state, value) {
      state.gettingPortalSession = value
    },
    SET_PORTAL_SESSION(state, value) {
      state.portalSession = value
    },
    SET_ORGANIZATIONS_CURRENT_PAGE(state, id) {
      state.organizationsCurrentPage = id
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    SET_FETCHING_COUNTRIES(state, value) {
      state.fetchingCountries = value
    },
    SET_COUNTRIES(state, value) {
      state.countries = value
    },
  },
  actions: {
    fetchOrganizations({ commit }, query) {
      if (!query.returnOnly) {
        commit('SET_FETCHING_ORGANIZATIONS', true)
      }
      return new Promise((resolve, reject) => {
        api('captain')
          .get(
            `/organizations?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`,
          )
          .then(response => {
            if (!query.returnOnly) {
              commit('SET_ORGANIZATIONS', response.data)
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            if (!query.returnOnly) {
              commit('SET_FETCHING_ORGANIZATIONS', false)
            }
          })
      })
    },

    addOrganization({ commit }, organization) {
      commit('SET_ADDING_ORGANIZATION', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .post('/organizations', organization)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_ORGANIZATION', false)
          })
      })
    },

    updateOrganization({ commit }, organization) {
      commit('SET_UPDATING_ORGANIZATION', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .put(`/organizations/${organization.organizationId || organizationId()}`, organization)
          .then(response => {
            if (!organization.organizationId) commit('GET_ORGANIZATION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_ORGANIZATION', false)
          })
      })
    },

    getOrganization({ commit }, id) {
      commit('SET_GETTING_ORGANIZATION', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/organizations/${id}`)
          .then(response => {
            commit('GET_ORGANIZATION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_ORGANIZATION', false)
          })
      })
    },

    inviteUser({ commit }, user) {
      commit('SET_INVITING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .post(`/organizations/${organizationId()}/users`, user)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_INVITING_USER', false)
          })
      })
    },

    fetchUsers({ commit }, payload) {
      let query = `/organizations/${organizationId()}/users?PageIndex=${
        payload.pageIndex
      }&PageSize=${payload.pageSize}`
      if (payload.search) {
        query += `&Search=${payload.search}`
      }
      commit('SET_FETCHING_USERS', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(query)
          .then(response => {
            commit('SET_USERS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_USERS', false)
          })
      })
    },

    getUser({ commit }, userId) {
      commit('SET_GETTING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/organizations/${organizationId()}/users/${userId}`)
          .then(response => {
            commit('GET_USER', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_USER', false)
          })
      })
    },

    updateUser({ commit }, query) {
      commit('SET_UPDATING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .put(`/organizations/${organizationId()}/users/${query.userId}`, {
            roleId: query.roleId,
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_USER', false)
          })
      })
    },

    deleteUser({ commit }, userId) {
      commit('SET_REMOVING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .delete(`/organizations/${organizationId()}/users/${userId}`)
          .then(response => {
            commit('REMOVE_USER', userId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_USER', false)
          })
      })
    },

    paymentIntent({ commit }, id) {
      commit('SET_FETCHING_PAYMENT_INTENT', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/organizations/${id}/billings/payment-intent`, { id })
          .then(response => {
            commit('SET_SECRET', response.data.result)
            commit('SET_ORGANIZATION_ID', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_PAYMENT_INTENT', false)
          })
      })
    },

    confirmCard({ commit }, id) {
      commit('SET_CONFIRMING_CARD', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/organizations/${id}/billings/confirm-card`, { id })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CONFIRMING_CARD', false)
          })
      })
    },

    getBillingDetails({ commit }) {
      commit('SET_GETTING_BILLING_DETAILS', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/organizations/${organizationId()}/billings`)
          .then(response => {
            commit('SET_BILLING_DETAILS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_BILLING_DETAILS', false)
          })
      })
    },

    getPortalSession({ commit }) {
      commit('SET_GETTING_PORTAL_SESSION', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .post(
            `/organizations/${organizationId()}/billings/create-customer-portal-session`,
          )
          .then(response => {
            commit('SET_PORTAL_SESSION, response.data.result')
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_PORTAL_SESSION', false)
          })
      })
    },

    fetchCountries({ commit }) {
      commit('SET_FETCHING_COUNTRIES', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get('/countries?pageSize=300')
          .then(response => {
            commit('SET_COUNTRIES', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_COUNTRIES', false)
          })
      })
    },
  },
}
